/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { NAME_PATTERN, USER_NAME_PATTERN } from '../constants';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NB_AUTH_OPTIONS, NbAuthSocialLink, NbAuthService, NbAuthResult } from '@nebular/auth';
import { Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ActionDescription, User, UserData, UserTypeOptions, UserTypeValue } from '../../../@core/interfaces/common/users';
import { TenantData } from '../../../@core/interfaces/masters/tenant';
import { getDeepFromObject } from '../../helpers';
import { EMAIL_PATTERN } from '../constants';
import { TenantListComponent } from '../../../@auth/components/tenant-list/tenant-list.component';
import { UsertypeData } from '../../../@core/interfaces/masters/usertype';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { EmployeeData } from './../../../@core/interfaces/masters/employee';
import { PhysicianData } from './../../../@core/interfaces/masters/physician-mst';
import { INgxSelectOption } from 'ngx-select-ex';
import { TenantBranchData } from '../../../@core/interfaces/masters/tenantbranch';
import { CollectionReportData } from '../../../@core/interfaces/report/collectionReport';
import { DistrictData } from './../../../@core/interfaces/masters/district';
import { HttpParams } from '@angular/common/http';
import { SharedService } from '../../../@core/interfaces/masters/SharedService';
import { access } from '../../../data/access-constants';
import { JobCategoryData } from '../../../@core/interfaces/masters/jobCategory';
import { OPDSequenceMStData } from '../../../@core/interfaces/masters/opdsequence-mst';
import * as refmode from './../../../data/refmode.json';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import {PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import {CountryMst } from '../../../@core/interfaces/masters/country';
@Component({
  selector: 'ngx-register',
  styleUrls: ['./register.component.scss'],
  templateUrl: './register.component.html',
})
export class NgxRegisterComponent implements OnInit {
  @Input() editUserId: any;
  @Input() fromSelfProfileId: any;
  placeholder: string = "Select";
  allowClear: any = true;
  multiple: boolean = true;
  multipleforType: boolean = false;
  landingPageUrl:string;
  @ViewChild('editTenantComp') tenantTabInstance: TenantListComponent;
  typeOptions: UserTypeOptions[] = [
    { type: 'Employee', value: 1 },
    { type: 'Physician', value: 2 },
    { type: 'Admin', value: 3 },
  ];
  minLength: number = 8;
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  isFullNameRequired: boolean = this.getConfigValue('forms.validation.fullName.required');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');
  redirectDelay: number = this.getConfigValue('forms.register.redirectDelay');
  showMessages: any = this.getConfigValue('forms.register.showMessages');
  strategy: string = this.getConfigValue('forms.register.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');
  isTenantIdRequired: boolean = this.getConfigValue('forms.validation.tenantId.required');
  isFirstNameRequired: boolean = this.getConfigValue('forms.validation.fName.required');
  isLastNameRequired: boolean = this.getConfigValue('forms.validation.lName.required');
  isMobilNumRequired: boolean = this.getConfigValue('forms.validation.mobileNum.required');
  resetSuccess:boolean=false;
  passwordResetAlertMessage:string;
  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  resetOtpSentToUser:boolean=false;
  editUserPostData: any = {};
  resetPasswordClickFlag: boolean = false;
  pharmacySettingsSuccess: boolean = false;
  pharmacySettingsFaild: boolean = false;
  registerForm: FormGroup;
  fromtenantId: string = localStorage.getItem("tenantId");
  branchId: string = localStorage.getItem("branchId");
  loginId: string = localStorage.getItem("userId");
  customerType: string = localStorage.getItem("customerType").toLocaleLowerCase();

  isRadiologyAccess:boolean=false;
  protected readonly unsubscribe$ = new Subject<void>();
  tenantData: any;
  userData: any;
  sessionTimeValue:number=60;
  isSuperUserFlag:boolean=false;
  isEdit: boolean = false;
  @Output() dataEvent: EventEmitter<any> = new EventEmitter<any>();
  isSubmitted: boolean=false;
  userCount: any = "0";
  progressBarValue: number;
  myModel: boolean = true;
  isEditTenant: boolean = false;
  isProgressFull: boolean = false;
  totalLicense: any;
  userTypeData: any;
  selectValue: any;
  showContactAdmin: boolean;
  fromEditProfile: boolean;
  resetPasswordForm: FormGroup;
  pwdAuthenticated: boolean = false;
  pwdErrorMsg: string = "";
  pwdLinkClicked: boolean =false;
  isUpdated: boolean =false;
  isPwdUpdated: boolean =false;
 empdata:any;
  phydata:any;
  dowant:boolean=false;
  empflag:boolean=false;
  phyflag:boolean=false;
  isAlreadyRegistered: boolean =false;
  //New
  isCreate:boolean=false;
  editaccess:boolean=false;
  tenantBranchData: any;

  isrouteSave:boolean=false;
  isrouteUpdate:boolean=false;
  adduserRouting:boolean=false;
  errorSavemsg:boolean=false;
  mandatorymsg:boolean=false;
  dataExistsmsg:boolean=false;
  savemsg:boolean=false;
  ageMin: Date;
  routingUserData:any=[];
  getbyuserData:any;
  moduleList=[
    {id:"MODL002", name: "Registration"},
    {id:"MODL003", name: "Appointment"},
    {id:"MODL005", name: "Lab"}

  ];
  countriesList: CountryMst[];
  pagesList=[
    {id:"PG_PAT_REG_MST",name:"Patient Registration"},
    {id:"PG_APP_BOOKING",name:"Book Appointment"},
  ];
  printList=[
    {id:0,name:"ID Card"},
    {id:1,name:"OPD Slip"},
    {id:2,name:"Registration Summary"},
  ];
  routingPageList=[
    {id:0,name:"Patient List"},
    {id:1,name:"Frontdesk Dashboard"},
    {id:2,name:"New Registration"},
    {id:3,name:"Appointment Booking"},
    {id:6,name:"Time Slot Appointment Booking"}
  ];

  radiologyList=[];
  radioloUserDetails:any;

  moduleData: any = [];
  accessabilitysettingsData: Array<any> = [];
  pharmacySettingsPopup: boolean = false;
  pharmacyData: any[];
  pharmacyAccessFinaldata: any[];
  languageList: Array<any>=[];
  langCode: number
  filteredTransDetails: any = {};
  filterFlag: boolean;
  filterForm:FormGroup;
  filterReference:Array<any>=[];
  filterTypeList:Array<any>=['Doctor','District','Prescription Location','Referral'];
  isSubmit: boolean;
  userFilterArray:Array<any>=[];
  dataFilterFlag:boolean=false;
  dataFilterFlagCancel:boolean=false;
  districtList:Array<any>=[];
  phyList:Array<any>=[];
  multipleFlag:boolean=false;
  duplicateFlag:boolean=false;
  editData:any = {};
  isEditComponent:boolean=false;
  multipleData:string;
  editIndex:number;
  deleteFlag:boolean=false;
  deleteIndex:number;
  deleteNotify:boolean=false;
  defaultCountry = localStorage.getItem("LoginCountryDet") ? JSON.parse(localStorage.getItem("LoginCountryDet"))?.countryId : '';
  countryList:Array<any>=[];
  pageTaskIds: any[];
  phyView: boolean = false;
  btnView: boolean = false;
  aptView: boolean = false;
   isAlreadyExists:boolean=false;
  isAlreadyExistsMessage:string;
  isDefaultPopup:boolean=false;
  yesDefault:any = {};
  printAdministratorList:Array<any>=[{display:"Yes",value:true},{display:"No",value:false}];
  approverLevelList:Array<{id:number,name:string}>=[{id:0,name:'Top Level'},{id:1,name:'1st Level'},{id:2,name:'2st Level'},{id:3,name:'3st Level'}]
  discountMethodType:Array<{id:string,name:string}>=[{id:'Automatic',name:'Automatic Discount Request'},{id:'Manual',name:'Manual Discount Request'}]
  maxMobileNumberLength: number = 10;
  minMobileNumberLength: number = 10;
  userConditionErrorMessage: string;
  jobCategoryData:Array<any>=[];
  monitorDatas:Array<any>=[];
  URL = `tokenMonitor/${this.fromtenantId}/${this.branchId}`;
  refmodList: any[] = (refmode as any).default;
  refList: any[] = [];
  empList: any[] = [];
  docList: any[] = [];
  docExList: any[] = [];
  campData: any[] = [];
  PatientList: any[] = [];
  branchDetails : any[] = [];
  selectedReferralModeName: string = '';
  countryCode = localStorage.getItem('LoginCountryCode');

  constructor(private opdSequenceService: OPDSequenceMStData,protected usertypeService: UsertypeData, protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},protected tenantBrchSrvc:TenantBranchData,
    protected cd: ChangeDetectorRef,private sharedService:SharedService,
    private fb: FormBuilder, protected rolesService: RolesData,private apiService:CollectionReportData,
    protected router: Router, private route: ActivatedRoute, protected tenantSrvc: TenantData, protected userService: UserData,protected employeeSrvc: EmployeeData,protected phySrvc: PhysicianData,protected districtSrvc: DistrictData, protected categorySrvc: JobCategoryData,private patAptSrv: PatientAppointmentData,protected patRegSrvc: PatientRegistrationData,) {
      
  }
  hasUppercase(value: string): boolean {
    return /[A-Z]/.test(value);
  }

  hasLowercase(value: string): boolean {
    return /[a-z]/.test(value);
  }

  hasNumeric(value: string): boolean {
    return /\d/.test(value);
  }

  hasSymbol(value: string): boolean {
    return /[!@#$%^&*()_+{}:<>?]/.test(value);
  }
  get fullName() { return this.registerForm.get('fullName'); }
  get fName() { return this.registerForm.get('fName'); }
  get lName() { return this.registerForm.get('lName'); }
  get mobileNum() { return this.registerForm.get('mobileNum'); }
  get email() { return this.registerForm.get('email'); }
  get password() { return this.registerForm.get('password'); }
  get confirmPassword() { return this.registerForm.get('confirmPassword'); }
  get terms() { return this.registerForm.get('terms'); }
  get userType() { return this.registerForm.get('userType'); }
  
  get editnewpassword() { return this.resetPasswordForm.get('editnewpassword'); }
  get editconfirmPassword() { return this.resetPasswordForm.get('editconfirmPassword'); }
  get editprofileoldpassword() { return this.resetPasswordForm.get('editprofileoldpassword'); }

  fetchPageAccess() {
    this.pageTaskIds =[];
      this.pageTaskIds.push(
        access.task.EHROPCASESHEET,
        access.task.SALESDASHBOARD,
        access.task.PHAPPBOOK
        );
      let matrixSearchData = {
        taskId: this.pageTaskIds,
        UserId: localStorage.getItem("userType")
      }
      this.rolesService.create(`${this.apiUrl}/userrole/${this.fromtenantId}/${this.branchId}/pageaccesssearch`, matrixSearchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        if(data.length > 0 ){
          let pharmacyView = data?.filter(element => access.task.EHROPCASESHEET == element.taskID);
          if(pharmacyView.length>0){
            this.phyView = true
          }
          let phyView = data?.filter(element => access.task.SALESDASHBOARD == element.taskID);
          if(phyView.length>0){
            this.btnView = true
          }
          let aptView = data?.filter(element => access.task.PHAPPBOOK == element.taskID);
          if(aptView.length>0){
            this.aptView = true
          }
        } 
  
      }, (error) => {
      }, () => {
      })
    }

  ngOnInit(): void {
    this.fetchPageAccess();
    this.fetchUsertype();
    this.fetchTenantData();
    this.fetchEmployee();
    this.fetchPhysician();
    this.fetchTenantBranch();
    this.rediologyData();
    this.loadMasterlangData();
    this.ageMin = new Date();
    this.loadGeo();
    this.fetchJobCategory();
    this.loadMonitor();

    const fullNameValidators = [
    ];
    this.isFullNameRequired && fullNameValidators.push(Validators.required);
    const firstNameValidators = [
    ];
    this.isFirstNameRequired && firstNameValidators.push(Validators.required);
    const lastNameValidators = [
    ];
    this.isLastNameRequired && lastNameValidators.push(Validators.required);
    const mobileNumValidators = [
    ];
    this.isMobilNumRequired && mobileNumValidators.push(Validators.required);
    const tenantIdValidators = [
    ];
    this.isTenantIdRequired && tenantIdValidators.push(Validators.required);

    const emailValidators = [
      Validators.pattern(EMAIL_PATTERN),
    ];

    const passwordValidators = [
      Validators.minLength(4),
      Validators.maxLength(this.maxLength),
      Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/)
    ];
    const resetPasswordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
      Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/)
    
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);
    const branchList = !!localStorage.getItem("branchAccessList") ? JSON.parse(localStorage.getItem("branchAccessList")) : [];
    if(Array.isArray(branchList) && branchList.length > 0) {
      const countryMst= branchList.find((branch) => branch?.id === this.branchId)?.country_Mst;
      if(!!countryMst){
        this.maxMobileNumberLength = countryMst?.maxMobileNumberLength ?? 10;
        this.minMobileNumberLength = countryMst?.minMobileNumberLength ?? 10;
      }
    }

    this.registerForm = this.fb.group({
      fullName: this.fb.control('', [Validators.pattern(USER_NAME_PATTERN)]),
      fName: this.fb.control('', [Validators.required,Validators.pattern(NAME_PATTERN)]),
      lName: this.fb.control('',[Validators.pattern(NAME_PATTERN)]),
      mobileNum: this.fb.control(null,[ Validators.required,Validators.pattern('^[0-9-]+$'), Validators.maxLength(this.maxMobileNumberLength), Validators.minLength(this.minMobileNumberLength)]),// [...mobileNumValidators]),
      email: this.fb.control('', [Validators.pattern(EMAIL_PATTERN)]),
      password: this.fb.control('', [...passwordValidators]),
      confirmPassword: this.fb.control('', [...passwordValidators]),
      tenantId: this.fb.control('', []),
      branchId: this.fb.control('', []),
      terms: this.fb.control(''),
      userType: this.fb.control(''),
      userFlag: this.fb.control(''),
       wantval: this.fb.control(''),
      empId: this.fb.control(''),
      phyId: this.fb.control(''),
      actionDescription: this.fb.control(''),
      doneBy: this.fb.control(''),
      isDeactivate: this.fb.control(''),
      branchLocation: this.fb.control(''),
      nationalHealthinformation: this.fb.control('2236549230'),
      nationalId: this.fb.control('2538796589'),
      sehaId: this.fb.control('2538796589'),
      DOBProvider: this.fb.control('12-05-1985'),
      radiologyPageAccess: this.fb.control(''),
      preferredLang:this.fb.control(''),
      approverLevel:this.fb.control(''),
      discountMethod:this.fb.control('Manual'),
      empDept: this.fb.control(''),
      empJobCat: this.fb.control(''),
      empDesg: this.fb.control(''),
      empBranch: this.fb.control(''),
      empType: this.fb.control(''),
      docDept: this.fb.control(''),
      docType: this.fb.control(''),
      userEndDate: this.fb.control(this.getNextWeek()),
      printAdministrator:this.fb.control(false,[Validators.required]),
      sessionTimeOut: this.fb.control(60),
      isDeviceFlag: this.fb.control(false),
      CustomerVerifiedFlag:this.fb.control(false),
      MobileAppRestrict:this.fb.control(false),
      countryId:this.fb.control(this.defaultCountry),
      dashboardId:this.fb.control('',[]),
      userMoniterId:this.fb.control(''),
    });
    this.resetPasswordForm = this.fb.group({
      editprofileoldpassword: this.fb.control(''),
      editnewpassword: this.fb.control('', [...resetPasswordValidators]),
      editconfirmPassword: this.fb.control('', [...resetPasswordValidators]),
      editMobileNum: this.fb.control('')

    });
    this.filterForm = this.fb.group({
      filterType: this.fb.control('',[Validators.required]),
      filterReference: this.fb.control('',[Validators.required]),
      defaultFlag: this.fb.control('',[Validators.required]),
      hideZeroStockMedicine:this.fb.control(''),
      branchId:this.fb.control(''),
      refEmpId:this.fb.control(''),
      refClinicId:this.fb.control(''),
      referralcampid:this.fb.control(''),
      searchPatMobile:this.fb.control(''),
      searchRegId:this.fb.control(''),
      refRegId:this.fb.control(''),
      refDocId:this.fb.control(''),
      othersName:this.fb.control('', [Validators.pattern('^[a-zA-Z\\s{1,}]+$')]),
      othersCountryCode:this.fb.control(this.countryCode),
      othersPhone:this.fb.control(''),
      othersAddress:this.fb.control(''),
    });
  
    if (this.fromSelfProfileId != null && this.fromSelfProfileId != undefined) {
      this.fromSelfProfile(this.fromSelfProfileId);
    }

    this.checkRadiologyModuleAccess()
  }

  routarrs=this.fb.array([
    this.fb.group({
      print:this.fb.control(''),
      route:this.fb.control('')
    }),
    this.fb.group({
      print:this.fb.control(''),
      route:this.fb.control('')
    })
  ]); 

  loadMonitor() {
    this.opdSequenceService.list(this.URL).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.monitorDatas = data
    }, (error) => {

    }, () => {
    });
  }
  toLowerCase(event: Event) {
  const input = event.target as HTMLInputElement;
  const value = input.value.toLowerCase();

  input.value = value;
  this.registerForm.get('email')?.setValue(value, { emitEvent: false });
}

  checkviewFlag(data){
    if(!!data){
        this.moduleData.forEach(module => {
          if(module.dashboardModuleId==data.dashboardModuleId){
            module.isview=data.isview;
          }
        });
    }
  }
  showPassword: boolean = false;
  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  checkprintFlag(data){
    if(!!data){
        this.moduleData.forEach(module => {
          if(module.dashboardModuleId==data.dashboardModuleId){
            module.isprint=data.isprint;
          }
        });
    }
  }

  checkSelectFlag(data){
    if(!!data){
      if(data.isdefault){
        this.moduleData.forEach(module => {
          if(module.dashboardModuleId!=data.dashboardModuleId){
            module.isdefault=false;
          }
        });
      }
      else{
        this.moduleData.forEach(module => {
            module.isdefault=false;
        });
      }
    }
  }

  getaddeddashboadrmoduleData(){
    this.usertypeService.getall(`dashboardAccess/${this.fromtenantId}/${this.branchId}/${this.editUserId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data.length>0){
        this.moduleData=[];
        let dashboadrData=data;
        dashboadrData.forEach(module => {
          let moduleData={
            id:module.id,
            dashboardModuleId:module.dashboardId,
            dashboardModuleType:module.dashboardMst.dashboardModuleType,
            dashboardModuleDesc:module.dashboardMst.dashboardModuleDesc,
            isview:module.canView=='N'?false:true,
            isprint:module.canPrint=='N'?false:true, 
            isdefault:module.isDefault=='N'?false:true
          }
          this.moduleData.push(moduleData);
      });
      }
      else{
        this.usertypeService.getall(`dashboardAccess/${this.fromtenantId}/${this.branchId}/dashboardMst`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.moduleData=[];
          if(data.length>0){
            data.forEach(data => {
              let moduleData={
                id:'',
                dashboardModuleId:data.id,
                dashboardModuleType:data.dashboardModuleType,
                dashboardModuleDesc:data.dashboardModuleDesc,
                isview:false,
                isprint:false,
                isdefault:false
              }
              this.moduleData.push(moduleData);
            });
          }
         }, (error) => {
         }, () => {
         });
      }   
      
   }, (error) => {
   }, () => {
   });
  }
  pwdLink()
  {
    this.resetPasswordForm.reset();
    this.resetPasswordForm.controls['editMobileNum'].setValue(this.registerForm.get("mobileNum").value);
    this.pwdLinkClicked = true;
    this.pwdAuthenticated = false;
  }
  onTypeSelect(event: INgxSelectOption[]) : void {
    if (event[0]?.data?.value == 1) {
      
      this.registerForm.get('empId').setValidators([Validators.required]);
      this.registerForm.get('empId').updateValueAndValidity();
      this.registerForm.get('phyId').clearValidators();
      this.registerForm.get('phyId').updateValueAndValidity();

      this.empflag=true;
      this.phyflag=false;
      this.landingPageUrl="pages/patientservices/Frontdesk-Dashboard";
    }
    else  if (event[0]?.data?.value == 2) {

      this.registerForm.get('phyId').setValidators([Validators.required]);
      this.registerForm.get('phyId').updateValueAndValidity();
      this.registerForm.get('empId').clearValidators();
      this.registerForm.get('empId').updateValueAndValidity();      

      this.empflag=false;
      this.phyflag=true;
      this.landingPageUrl="pages/reports/report-doctor-dashbrd/";
    }
    else
    {

      this.registerForm.get('empId').clearValidators();
      this.registerForm.get('empId').updateValueAndValidity();    
      this.registerForm.get('phyId').clearValidators();
      this.registerForm.get('phyId').updateValueAndValidity();    

      this.empflag=false;
      this.phyflag=false;
      this.landingPageUrl="pages/reports/dashboard";

    }

   
  }
  pwdLinkCancel()
  {
    this.pwdLinkClicked = false;
    this.resetPasswordForm.reset();
    this.resetPasswordForm.controls['editMobileNum'].setValue(this.registerForm.get("mobileNum").value);

  }
  fetchUsertype() {
    this.usertypeService.list(`tenants/${this.fromtenantId}/usertypes`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.userTypeData = data.value;


    }, (error) => {

    }, () => {

    }); 
  }
 
  
fetchTenantBranch():void {
  this.tenantBrchSrvc.list(`${this.fromtenantId}/tenantbranch`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.tenantBranchData = data.value;
    
  }, (error) => {

  }, () => {

  });

}

clickedResetPasswordButton(value:any){
  
  this.resetPasswordClickFlag=value;
}

generateRandomPassword() {
  let result=' ';
  let length=6;
  const characters ='abcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result.substring(1);
}

resetPasswordByAdmin(){
    
    let payload = {
      purpose: "resetpasswordbyadmin",
      createdBy: this.loginId,
      createdFor: this.userData.id,
      toPhoneNumber: this.registerForm.get("mobileNum").value,
      initiatedForTenantId:this.fromtenantId,
      initiatedForBranchId:this.branchId,
         email: [{
           emailId: this.registerForm.get("email").value,
           senderName: this.registerForm.get("fullName").value
         }],
    }
         this.apiService.searchList("communication/" + this.fromtenantId + '/' + this.branchId+'/sendOTPtoMobileNumber', payload).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          
          if(data.code=200){
         this.resetOtpSentToUser=true;
          this.resetPasswordClickFlag=false;
          }else{
            this.resetOtpSentToUser=false;

          }
    
        }, (error) => {
        }, () => {
        });    
       
}

  changePwd() {
    this.pwdErrorMsg = ""


    let n = this.resetPasswordForm.get('editnewpassword').value;
    let c = this.resetPasswordForm.get('editconfirmPassword').value;
    if (this.resetPasswordForm.valid) {
      if (n != null && n != undefined && n != "" && c != null && c != undefined && c != "") {
        if (n == c) {
          let resetPwdData = {
            mobileNumber: this.registerForm.get('mobileNum').value,
            password: this.resetPasswordForm.get('editnewpassword').value,
            confirmPassword: this.resetPasswordForm.get('editconfirmPassword').value,
            tenantId: this.fromtenantId
          }
   

          let pwdCheckData = {
            fullName: this.registerForm.get('mobileNum').value,
            password: this.resetPasswordForm.get('editprofileoldpassword').value,
            tenantId: this.fromtenantId,
            ChangePassword:resetPwdData
          }
       
          this.rolesService.create(`${this.apiUrl}/auth/loginauth`, pwdCheckData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

            if (data.result == "Reset-success") {
              this.passwordResetAlertMessage="Password Reset successfully..! Try Login now";
             this.resetSuccess=true;
             setTimeout(() => { 
              this.resetSuccess = false; 
            }, 4000);
            this.router.navigate(['/auth/logout']);
            }     
            else if(data.result == "failed") {
              this.pwdErrorMsg = "Password you entered is invalid!";
            }
          }, (error) => {
          }, () => {
            this.cd.detectChanges();
          });

        }
      }
    }

  
 
  }
  fromSelfProfile(id) {
    this.showContactAdmin = false;
    this.fetchTenantData();
    this.editUserId = id;
    if (this.editUserId > 0) {
      this.isEdit = true;
      this.fromEditProfile = true;
      this.rediologyData();
      this.getEditUserData();
    }



  }
  fromUserList(id, userCount, licanceCOunt) {
    this.adduserRouting=false;
    this.isSubmitted=false;
    this.isEdit = false;
    this.showContactAdmin = false;
    this.fetchTenantData();
    this.editUserId = id;
    this.totalLicense = licanceCOunt;
    this.userCount = userCount;
    this.isAlreadyExists=false;
    this.isAlreadyExistsMessage="";
    if(!this.isEdit && !this.adduserRouting){this.userFilterArray=[]}
    this.loadDoc();
    this.loadDistrict();
    if (licanceCOunt <= userCount && this.editUserId <= 0) {
      this.isEdit = false;
      this.showContactAdmin = true;
    }
    else {
      if (this.totalLicense != null && this.totalLicense != undefined) {
        var y: number = +this.totalLicense;
        this.progressBarValue = (this.userCount / y) * 100;
        if (this.progressBarValue == 100)
          this.isProgressFull = true;
      }

      if (+this.editUserId > 0) {
        this.isEdit = true;
        this.getEditUserData();
      }
      else {
        this.isEdit = false;
        this.registerForm.reset();
        this.registerForm.get('preferredLang')?.setValue(1001); 
        this.registerForm.get('discountMethod')?.setValue('Manual');  
        this.registerForm.get('printAdministrator')?.setValue(false);  
        this.registerForm.get('isDeviceFlag')?.setValue(false);  
        this.registerForm.get('sessionTimeOut')?.setValue(60);  
        this.registerForm.get('CustomerVerifiedFlag')?.setValue(false); 
        this.registerForm.get('MobileAppRestrict')?.setValue(false);
        this.registerForm.get('countryId')?.setValue(this.defaultCountry); 

      }
      
      //this.getaddeddashboadrmoduleData();
      document.getElementById("myCheck").click();
    }
    

    if(this.customerType=="trial"){
      if(!this.isEdit){
        this.registerForm.controls['userEndDate'].setValue(this.getNextWeek());
      }
      this.registerForm.get('userEndDate').clearValidators();
      this.registerForm.get('userEndDate').setValidators([Validators.required]);
      this.registerForm.get('userEndDate').updateValueAndValidity(); 
      
    }else{
      this.registerForm.controls['userEndDate'].setValue(null);
      this.registerForm.get('userEndDate').clearValidators();
      this.registerForm.get('userEndDate').updateValueAndValidity();
    }
  }

  private getNextWeek() {
    let result = new Date(); 
    result.setDate(new Date().getDate() + 7);
    return result;
  }
  onClose() {

    this.dataEvent.emit();
    this.empflag=false;
    this.phyflag=false;
    this.dowant =false;

    this.adduserRouting=false;
    this.multiple=true;
    this.routarrs.reset();
    this.isrouteSave=true;
    this.isrouteUpdate=false;
    this.isAlreadyExists=false;
    this.isAlreadyExistsMessage="";
  }
  submit() {
    this.isSubmitted = true;
    if(this.registerForm.valid && !this.isAlreadyExists){
      this.isSubmitted = false;
      
    if (this.isEdit)
      {
        if(this.registerForm.get('isDeactivate').value == true)
    {
      if(window.confirm('Are you sure you want to deactivate this user?'))
      {
        this.editRegister();
      }
      else
      return;
    }
    else{
      this.editRegister();
    }
      }
    else
      this.register();
  }
}
  onClear() {
    this.registerForm.reset();
    this.registerForm.get('discountMethod')?.setValue('Manual'); 
    this.registerForm.get('preferredLang')?.setValue(1001);  
    this.rediologyData();
    if(!this.isEdit){
      this.registerForm.controls['userEndDate'].setValue(this.getNextWeek());

    }
    this.isAlreadyExists=false;
    this.isAlreadyExistsMessage="";
    this.isAlreadyRegistered = false;
  }
  isAdmin: boolean = false;

  getEditUserData() {
    this.rediologyData();
    // Own profile: always users/current. Admin editing someone from the user list: users/{id}.
    const selfProfile = this.fromSelfProfileId != null && this.fromSelfProfileId != undefined;
    const user$ = selfProfile ? this.userService.getCurrentUser() : this.userService.get(this.editUserId);
    user$.pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if (!data) { return; }
      this.userData = data;
      this.getUserFilter();
      if(this.isRadiologyAccess==true){
        this.radiologyDataGetByUserId(data,this.editUserId);
      }
      
      if(this.userData.isSuperUser=="true"){this.isSuperUserFlag=true;}else{this.isSuperUserFlag=false;}
      if(this.userData.userFlag=="Admin"){this.isAdmin=true;}else{this.isAdmin=false;}

      if(this.userData.userFlag=="Admin" && this.userData.isSuperUser=="true"){
        this.registerForm.get('isDeactivate')?.disable();
      }else{
        this.registerForm.get('isDeactivate')?.enable();
      }

    }, (error) => {

    }, () => {
      this.loadUserForm();
    });
  }
  loadUserForm() {
    if (!this.userData) { return; }
    if (this.userData.userType != null || this.userData.userType != undefined) {
      var splitted = this.userData.userType.split(",");
      this.registerForm.controls['userType'].setValue(splitted);

    }
    else {
      this.registerForm.controls['userType'].setValue("");
    }


    if(this.userData.branchLocation != null || this.userData.branchLocation != undefined){
    var branch = this.userData.branchLocation.split(",");   
    this.registerForm.controls['branchLocation'].setValue(branch);
    }
    else{
      this.registerForm.controls['branchLocation'].setValue("");
    }
    this.registerForm.controls['preferredLang'].setValue(this.userData.preferredlanguage);
    this.registerForm.controls['approverLevel'].setValue(this.userData.approverLevel);    
    let extractUserJson=JSON.parse(this.userData.userJson);
    this.registerForm.controls['printAdministrator'].setValue((extractUserJson?.printAdministrator)??false);
    this.registerForm.controls['fullName'].setValue(this.userData.userName);
    this.registerForm.controls['sessionTimeOut'].setValue(this.userData.sessionTimeOut??60);
    this.registerForm.controls['isDeviceFlag'].setValue(this.userData.isDeviceFlag??false);
    this.registerForm.controls['CustomerVerifiedFlag'].setValue(this.userData.customerVerifiedFlag??false);
    this.registerForm.controls['MobileAppRestrict'].setValue(this.userData.mobileAppRestrict??false);
    this.sessionTimeValue = this.userData.sessionTimeOut??60;

     this.registerForm.controls['countryId'].setValue(this.userData.countryId);
     this.registerForm.controls['dashboardId'].setValue(this.userData?.dashboardId?(this.userData?.dashboardId?.split(',')?.map(Number) ):[]);
    this.registerForm.controls['userMoniterId'].setValue(this.userData?.userMoniterId);
    this.registerForm.controls['fName'].setValue(this.userData.firstName);
    this.registerForm.controls['lName'].setValue(this.userData.lastName);
    this.registerForm.controls['mobileNum'].setValue(this.userData.mobileNum);
    this.registerForm.controls['email'].setValue(this.userData.email !=null ? this.userData.email.toLowerCase() : null );
    this.registerForm.controls['userEndDate'].setValue(this.userData.userEndDate);

    //Setting dummy values
    this.registerForm.controls['password'].setValue('12345@Abc');
    this.registerForm.controls['confirmPassword'].setValue('12345@Abc');


    
    this.registerForm.controls['terms'].setValue('');
    this.registerForm.controls['tenantId'].setValue(this.userData.tenantId);
    this.registerForm.controls['branchId'].setValue(this.userData.branchId);
    this.resetPasswordForm.controls['editMobileNum'].setValue(this.userData.mobileNum);
    this.registerForm.controls['userFlag'].setValue(this.userData.userFlag);
    this.registerForm.controls['isDeactivate'].setValue(this.userData.isDeactivate == "true"? true:false);
    this.registerForm.controls['discountMethod'].setValue(this.userData.discReqMethod ?? 'Manual');
  
    if(this.userData.userFlag == UserTypeValue.EMPLOYEE )
    {
      var editEmployeeValue = this.empdata.find(element => this.userData.empId == element.id);
      this.registerForm.controls['empId'].setValue(editEmployeeValue.id);
      this.registerForm.controls['phyId'].setValue("");
      this.registerForm.controls['empDept'].setValue(editEmployeeValue.department.name);
      this.registerForm.controls['empJobCat'].setValue(editEmployeeValue.jobCategory.name);
      this.registerForm.controls['empDesg'].setValue(editEmployeeValue.designation.name);
      this.registerForm.controls['empBranch'].setValue(editEmployeeValue.tenantBranch.area);
      this.registerForm.controls['empType'].setValue(editEmployeeValue.employeeType);
      this.registerForm.controls['docDept'].setValue(null);
      this.registerForm.controls['docType'].setValue(null);

      this.empflag = true;
      this.phyflag = false;

    }
    else if(this.userData.userFlag == UserTypeValue.PHYSICIAN){
      var editPhysicianValue = this.phydata.find(element => this.userData.phyId == element.id);
      this.registerForm.controls['phyId'].setValue(editPhysicianValue.id);
      this.registerForm.controls['empId'].setValue("");
      this.registerForm.controls['empDept'].setValue(null);
      this.registerForm.controls['empJobCat'].setValue(null);
      this.registerForm.controls['empDesg'].setValue(null);
      this.registerForm.controls['empBranch'].setValue(null);
      this.registerForm.controls['empType'].setValue(null);
      this.registerForm.controls['docDept'].setValue(editPhysicianValue.department.name);
      this.registerForm.controls['docType'].setValue(editPhysicianValue.jobType);


      this.empflag = false;
      this.phyflag = true;
    }
    else
    {
      this.registerForm.controls['empId'].setValue("");
      this.registerForm.controls['phyId'].setValue("");
      this.registerForm.controls['empDept'].setValue(null);
      this.registerForm.controls['empJobCat'].setValue(null);
      this.registerForm.controls['empDesg'].setValue(null);
      this.registerForm.controls['empBranch'].setValue(null);
      this.registerForm.controls['empType'].setValue(null);
      this.registerForm.controls['docDept'].setValue(null);
      this.registerForm.controls['docType'].setValue(null);
      this.empflag = false;
      this.phyflag = false;
    }
    this.getPharmacyAccessData(false);
  }
  get apiUrl(): string {
    return environment.apiUrl;
  }
  trim (el, arg) {
    el = el.replace (/\s{2,}/g,' ')
  
    this.registerForm.controls[arg].setValue(el.trim());
}
capitalize = (s,arg) => {
 s=s.charAt(0).toUpperCase()+ s.slice(1);
s = s.replace (/\s{2,}/g,' ');

 this.registerForm.controls[arg].setValue(s.trim());
}
  fetchTenantData(): void {
    this.tenantSrvc.getById(`${this.apiUrl}/tenants/${this.fromtenantId}/tenantmst/${this.fromtenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.tenantData = data;
      this.totalLicense = this.tenantData.noOfLicences;
    }, (error) => {

    }, () => {

    });
  }
  
  onSliderChange(event: any) {

    this.sessionTimeValue=parseInt(event.target.value);

  }
  convertMinutesToHours(minutes: number): string {
    if (!minutes || minutes < 0) return '0h 0m';
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return `${hours}h ${remainingMinutes}m`;
  }
  editRegister(): void {
    
    this.isSubmitted = true;
    var selected;
    var actionDesc;
    var branchSelected;
    if (this.registerForm.get('userType').value != null && this.registerForm.get('userType').value != undefined)
      selected = this.registerForm.get('userType').value.toString();
      if (this.registerForm.get('branchLocation').value != null && this.registerForm.get('branchLocation').value != undefined)
      branchSelected = this.registerForm.get('branchLocation').value.toString();
      
      if( this.registerForm.get('isDeactivate').value == true)
      actionDesc = ActionDescription.DEACTIVATE;
      else if(this.userData.isDeactivate == "true" && this.registerForm.get('isDeactivate').value == false)
      actionDesc = ActionDescription.ACTIVATE;
      else
      actionDesc = ActionDescription.UPDATE;
    this.editUserPostData = {
      branchId: this.registerForm.get('branchId').value,
      email: this.registerForm.get('email').value,
      firstName: this.registerForm.get('fName').value,
      id: this.userData.id,
      isSuperUser: this.userData.isSuperUser,
      lastName: this.registerForm.get('lName').value,
      mobileNum: this.registerForm.get('mobileNum').value,
      tenantId: this.registerForm.get('tenantId').value,
      userName: this.registerForm.get('fullName').value,
      empId: this.registerForm.get('empId').value,
      phyId: this.registerForm.get('phyId').value,
      userFlag: this.registerForm.get('userFlag').value,
      loginUserType: this.userData.loginUserType,
      userType: selected,
      doneBy: this.loginId,
      passwordResetFlag:this.userData.passwordResetFlag,
      landingpageUrl:this.landingPageUrl,
      //New
      branchLocation: branchSelected,
      isDeactivate:this.registerForm.get('isDeactivate').value,
      actionDescription: actionDesc,
      passwordResetDate: this.userData.passwordResetDate,
      preferredlanguage:this.registerForm.get('preferredLang').value,
      userEndDate:this.customerType=="trial"? this.registerForm.get('userEndDate').value:null,
      discReqMethod:this.registerForm.get('discountMethod').value ?? 'Manual',
      userFilterConditionDet:this.userFilterArray || [],
      userJsonValues:{"printAdministrator":this.registerForm.get('printAdministrator').value},
      isDeviceFlag:this.registerForm.get('isDeviceFlag').value ?? false,
      sessionTimeOut:this.registerForm.get('sessionTimeOut').value ?? 60,
      approverLevel:this.registerForm.get('approverLevel').value,
      CustomerVerifiedFlag:this.registerForm.get('CustomerVerifiedFlag').value ?? false,
      MobileAppRestrict:this.registerForm.get('MobileAppRestrict').value ?? false,
      createdDate: this.userData?.createdDate ?? new Date(),
      createdIp: this.userData?.createdIp ?? null,
      createdBy: this.userData?.createdBy ?? this.loginId,
      updatedDate: new Date(),
      updatedIP: this.userData?.updatedIP ?? null,
      updatedBy: this.loginId,
      countryId:this.registerForm.get('countryId').value,
      dashboardId:this.registerForm.get('dashboardId').value?.join(',')??'',
      userMoniterId:this.registerForm.get('userMoniterId').value
    }
    this.userService.update(this.editUserPostData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.userData = data;
      if(data.id === parseInt(this.loginId)){
        this.sharedService.updatePrintAdminStatus({isPrintAdmin:this.registerForm.get('printAdministrator').value});
        localStorage.setItem('sessionTimeOutSettings',(this.registerForm.get('sessionTimeOut').value??60).toString());

        this.langCode = data.preferredlanguage;
        const localStorageData = localStorage.getItem('loginresult');
        if (localStorageData) {
        const local = JSON.parse(localStorageData);
        local.response.body.preferredLanguage = data.preferredlanguage;
        let updates = JSON.stringify(local);
        localStorage.setItem('loginresult',updates)}
        this.getData();
      }

      localStorage.setItem("discReqMethod",data?.discReqMethod ?? 'Manual')

      this.isSubmitted = false;
    }, (error) => {
      this.isSubmitted = false;
    }, () =>{
      
      if(this.isRadiologyAccess==true){
        this.UpdateRadiologyAccess();
      }
      // Promise.all([this.saveaccessabilitysettings(this.userData)])
      this.insertRoles();

     
          });
    
    
  }
  UpdateRadiologyAccess(){
    var postData=[];

    var radListSelected=this.registerForm.get('radiologyPageAccess').value;
    for(var i=0;i<=radListSelected.length-1;i++){
      postData.push({
        "Id":0,
        "UserId":this.userData.id,
        "ServiceSubCategoryId":radListSelected[i],
        "TenantId":this.userData.tenantId,
        "BranchId":this.userData.branchId
      })
    }


      this.rolesService.create(`${this.apiUrl}/${this.userData.tenantId}/${this.userData.branchId}/labworkordermst/radOrderAccessDet/${this.userData.id}`,postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

 
    });

    
  

  }
  
  get fval(): { [key: string]: AbstractControl } { return this.registerForm.controls; }
  get resetfval(): { [key: string]: AbstractControl } { return this.resetPasswordForm.controls; }

  async register() {
    this.isAlreadyRegistered = false;
    this.isSubmitted = true;
    this.registerForm.controls["tenantId"].setValue(this.tenantData.tenantUserId);
    this.registerForm.controls["branchId"].setValue(this.branchId);
    this.registerForm.controls["actionDescription"].setValue(ActionDescription.CREATE);
    this.registerForm.controls["doneBy"].setValue(this.loginId);
    this.registerForm.controls["isDeactivate"].setValue(false);

    this.errors = this.messages = [];

    // Enforce the password policy on submit (min 8, upper, lower, number, special).
    // The control validators alone are only cosmetic unless we block the POST here.
    if (this.password.invalid || this.confirmPassword.invalid ||
        this.password.value !== this.confirmPassword.value) {
      this.isSubmitted = true;
      this.password.markAsTouched();
      this.confirmPassword.markAsTouched();
      this.cd.detectChanges();
      return;
    }

    let postData = {
      fullName:  this.registerForm.get('fName').value,
      fName:  this.registerForm.get('fName').value,
      lName: "",
      mobileNum:this.registerForm.get('mobileNum').value,
      email:  this.registerForm.get('email').value,
      password: this.registerForm.get('password').value,
      confirmPassword: this.registerForm.get('confirmPassword').value,
      tenantId: this.tenantData.tenantUserId,
      branchId: this.branchId,
      isSuperUser:"false",
      userType:this.registerForm.get('userType').value,
      doneBy: 0,
      empId: this.registerForm.get('empId').value,
      phyId: this.registerForm.get('phyId').value,
      userFlag: this.registerForm.get('userFlag').value,
      actionDescription: ActionDescription.CREATE,
      isDeactivate:"false",
      landingpageUrl:this.landingPageUrl,
      branchLocation: this.registerForm.get('branchLocation').value,
      preferredlanguage:this.registerForm.get('preferredLang').value,
      discReqMethod:this.registerForm.get('discountMethod').value ?? 'Manual',
      userEndDate:this.customerType=="trial"? this.registerForm.get('userEndDate').value:null,
      userJsonValues:{"printAdministrator":this.registerForm.get('printAdministrator').value},
      isDeviceFlag:this.registerForm.get('isDeviceFlag').value ?? false,
      sessionTimeOut:this.registerForm.get('sessionTimeOut').value ?? 60,
      approverLevel:this.registerForm.get('approverLevel').value,
      CustomerVerifiedFlag:this.registerForm.get('CustomerVerifiedFlag').value ?? false,
      MobileAppRestrict:this.registerForm.get('MobileAppRestrict').value ?? false,
      createdDate: new Date(),
      createdIp: null,
      createdBy: this.loginId,
      updatedDate: null,
      updatedIP: null,
      updatedBy: null,
      countryId:this.registerForm.get('countryId').value,
      dashboardId:this.registerForm.get('dashboardId').value?.join(',')??'' ,
      userMoniterId:this.registerForm.get('userMoniterId').value
    }
    this.errors.length = 0;
    this.userService.userCreate(`${this.apiUrl}/auth/create`, postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.isSubmitted = false;

       if(data){
        // Promise.all([this.saveaccessabilitysettings(data)])
        this.insertRoles();
        var radListSelected=this.registerForm.get('radiologyPageAccess').value;

        this.getUSerId(postData.mobileNum,radListSelected);
        localStorage.setItem("discReqMethod",data?.discReqMethod ?? 'Manual')

      } else if(!data){

        this.isAlreadyRegistered = true;

      }
this.cd.detectChanges();
    }, (error) => {
      this.isSubmitted = false;
      this.errors = [ (error && error.error && error.error.message) || 'Unable to create user. Please choose a stronger password and try again.' ];
      this.cd.detectChanges();
    });

    
  }
  getUSerId(mobile:any,arr){
      this.userService.userList(`users/userlist/${this.fromtenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        
        var datas=data.filter((val)=>{
          return val.mobileNum==mobile;
        });
        if(this.isRadiologyAccess==true && arr?.length>0){
          this.saveRadiologyAccess(datas);
        }
        this.saveAPI(datas)

      });
  }
  saveRadiologyAccess(data:any){

    var postData=[];

    var radListSelected=this.registerForm.get('radiologyPageAccess').value;

    for(var i=0;i<=radListSelected.length-1;i++){
      postData.push({
        "UserId":data[0].id,
        "ServiceSubCategoryId":radListSelected[i],
        "TenantId":data[0].tenantId,
        "BranchId":data[0].branchId
      })
    }

    if(postData.length>0){
    this.rolesService.create(`${this.apiUrl}/${data[0].tenantId}/${data[0].branchId}/labworkordermst/radOrderAccessDet/${data[0].id}`,postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    
    });
  }

  }
  getInsertedUser() {

  }
  insertRoles() {
    let searchData = {
      tenantId: this.fromtenantId,
      branchId: this.branchId,
      rolesId: this.registerForm.get("userType").value,
      phoneNum: this.registerForm.get("mobileNum").value,
      email: this.registerForm.get("email").value


    }
    this.rolesService.create(`${this.apiUrl}/userpageaccess/search`, searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    
      this.isUpdated = true;
      setTimeout(() => {
        this.isUpdated = false;
        this.dataEvent.emit();
      }, 2000);
    }, (error) => {
    }, () => {
     
    });
  }

  saveaccessabilitysettings(userdata){
    let defaultEHRData=this.moduleData.filter(module => module.isdefault==true)
    if(defaultEHRData.length<=0){
      this.moduleData.forEach(data => {
        if(data.dashboardModuleId==1){
          data.isdefault=true;
        }
      });
    }
    
    this.accessabilitysettingsData=[];
    this.moduleData.forEach(module => {
      let settingsData={
        userId: userdata.id,
        dashboardId: module.dashboardModuleId,
        dashboardMst: null,
        canView: module.isview==false?'N':'Y',
        canPrint: module.isprint==false?'N':'Y',
        isDefault: module.isdefault==false?'N':'Y',
        branchId: this.branchId,
        branch: null,
        tenantId: this.fromtenantId,
        tenant: null
      }
      this.accessabilitysettingsData.push(settingsData);
    });
   
    this.rolesService.create(`${this.apiUrl}/dashboardAccess/${this.fromtenantId}/${this.branchId}`, this.accessabilitysettingsData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.insertRoles();
    }, (error) => {
    }, () => {

    });
  }

  editTenant() {
    this.isEditTenant = true;
    this.tenantTabInstance.callEdit(this.tenantData);
  }
  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }
  refreshUser(event) {
    this.isEditTenant = false;
    this.showContactAdmin = false;
    this.dataEvent.emit();
  }
  fetchEmployee()
  {
    this.employeeSrvc.list(`tenants/${this.fromtenantId}/${this.branchId}/employee/all`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.empdata = data.value;

    }, (error) => {

    }, () => {

    });

  }
  fetchPhysician()
  {
    this.phySrvc.list("physicians/" + this.fromtenantId + '/' + this.branchId+ `/clinicalActivePhysicians?referralType=1&isActive=`+true+`&isClinical=true`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.phydata = data.details;

    }, (error) => {

    }, () => {

    });

  }
  togglewantvalE()
  {
    if(this.registerForm.get('wantvalE').value==true)
    {
      this.registerForm.controls['wantvalP'].setValue(false)
      this.empflag=true;
      this.phyflag=false;
     
    }
    else{
      this.registerForm.controls['wantvalP'].setValue(true)
      this.empflag=false;
      this.phyflag=true;
    }
  }
  togglewantvalP()
  {
    if(this.registerForm.get('wantvalP').value==true)
    {
      this.registerForm.controls['wantvalE'].setValue(false)
      this.phyflag=true;
      this.empflag=false;
    }
    else{
      this.registerForm.controls['wantvalE'].setValue(true)
      this.phyflag=false;
      this.empflag=true;
    }
  }
  dowantEP()
  {
    if(this.dowant==false)
    {
    this.dowant=true;
    this.empflag=false;
    this.phyflag=false;
    this.registerForm.controls['wantvalP'].setValue(false)
    this.registerForm.controls['wantvalE'].setValue(false)
   
    }
    else
    {
    this.dowant=false;
    this.empflag=false;
    this.phyflag=false;
    this.registerForm.controls['wantvalP'].setValue(false)
    this.registerForm.controls['wantvalE'].setValue(false)
    }
  }
  empchange(event:any)
  {
    if(this.editUserId==null || this.editUserId==undefined || this.editUserId=="0"){
      this.registerForm.controls['fName'].setValue(event[0].data.firstName)
      this.registerForm.controls['lName'].setValue(event[0].data.lastName)
      if(event[0].data.lastName!=null)
      this.registerForm.controls['fullName'].setValue(event[0].data.firstName+" "+event[0].data.lastName)
      else
      this.registerForm.controls['fullName'].setValue(event[0].data.firstName)
      this.registerForm.controls['mobileNum'].setValue(event[0].data.mobile)
      this.registerForm.controls['email'].setValue(event[0].data.email.toLowerCase())
      this.registerForm.controls['empDept'].setValue(event[0].data.department.name);
      this.registerForm.controls['empJobCat'].setValue(event[0].data.jobCategory.name);
      this.registerForm.controls['empDesg'].setValue(event[0].data.designation.name);
      this.registerForm.controls['empBranch'].setValue(event[0].data.tenantBranch.area);
      this.registerForm.controls['empType'].setValue(event[0].data.employeeType);
      this.registerForm.controls['docDept'].setValue(null);
      this.registerForm.controls['docType'].setValue(null);
    }
  }
  phychange(event:any)
  {
    if(this.editUserId==null || this.editUserId==undefined || this.editUserId=="0"){
    this.registerForm.controls['fName'].setValue(event[0].data.name)
    this.registerForm.controls['lName'].setValue(event[0].data.lastName)
    if(event[0].data.lastName!=null)
    this.registerForm.controls['fullName'].setValue(event[0].data.name+" "+event[0].data.lastName)
    else
    this.registerForm.controls['fullName'].setValue(event[0].data.name)
    this.registerForm.controls['mobileNum'].setValue(event[0].data.mobile)
    this.registerForm.controls['email'].setValue(event[0].data.email)
    this.registerForm.controls['empDept'].setValue(null);
    this.registerForm.controls['empJobCat'].setValue(null);
    this.registerForm.controls['empDesg'].setValue(null);
    this.registerForm.controls['empBranch'].setValue(null);
    this.registerForm.controls['empType'].setValue(null);
    this.registerForm.controls['docDept'].setValue(event[0].data.department.name);
    this.registerForm.controls['docType'].setValue(event[0].data.jobType);
    }
  }


//  User Page Routing start 
  fromuserListShowData(id,licanceCOunt){
    this.fetchPageAccess();
    this.isrouteSave=true;
    this.isrouteUpdate=false;
    this.isEdit = true;
    this.showContactAdmin = false;
    this.fetchTenantData();
    this.editUserId = id;
    this.totalLicense = licanceCOunt;
    this.registerForm.reset();
    this.registerForm.get('preferredLang')?.setValue(1001);
    this.registerForm.get('discountMethod')?.setValue('Manual');  
    this.phyflag=false;
    this.getEditUserData();
    this.moduleData=0;
    this.fromEditProfile=false;
    this.adduserRouting=true;
    this.multiple=false;
    this.servs();
    this.isAlreadyExists=false;
    this.isAlreadyExistsMessage="";
  }

  //User Page Routing User Details
  
  servs(){
   
    this.userService.get(this.editUserId).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.routingUserData=data;
      this.getsuserdatas();
    }); 
  }

//User Page Routing Get User Routing Details

  getsuserdatas(){
 
    var tenantid=this.routingUserData.tenantId;
    var branchid=this.routingUserData.branchId;
    var userid=this.routingUserData.id;

    
    this.usertypeService.getall(`dashboardRouting/${tenantid}/${branchid}/${userid}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.getbyuserData=data;
      this.putval();
     }, (error) => {
     }, () => {
     });

    
  }

//User Page Routing Set Value

  putval(){

    if(this.getbyuserData.length>0){
      this.isrouteUpdate=true;
      this.isrouteSave=false;
      for(var i=0;i<=this.getbyuserData.length-1;i++){

        var modulID=this.getbyuserData[i].moduleId;
        var indexes=this.moduleList.findIndex((val)=>{
          return val.id==modulID;
        })
    this.routarrs.at(indexes).patchValue({print:parseInt(this.getbyuserData[i].printRoutingPageUrl),route:parseInt(this.getbyuserData[i].nextRoutingPageUrl)})
    
    
      }
     
      
    }
    else{
      this.isrouteSave=true;
      this.isrouteUpdate=false;
    }
  }

//User Page Routing Save

routeSave(){
  let checkIsEmpty=[];
  let dashroutingDetails=[];
  let arr=this.routarrs.value;

  checkIsEmpty=arr.filter((val)=>{
      return val.print!==''&&val.print!==null&&val.route!==''&&val.route!==null
  });

  if(checkIsEmpty.length>0){

  for(var i=0;i<=arr.length-1;i++){
    if(arr[i].print===''||arr[i].print===null||arr[i].route===''||arr[i].route===null){

      dashroutingDetails.push({
        "userId": this.routingUserData.id, 
    "moduleId": this.moduleList[i].id,
    "pageId":this.pagesList[i].id,
    "printRoutingPageUrl": "NaN",
    "nextRoutingPageUrl": "NaN",
    "createdDate": new Date(),
    "createdBy": this.routingUserData.id,
    "updatedBy": this.routingUserData.id,
    "createdIP": null,
    "updatedIP": null,
    "updatedDate": new Date(),
    "tenantId": this.routingUserData.tenantId,
    "tenant": null,
    "branchId": this.routingUserData.branchId,
    "branch": null
      })

    }
    else
    {
      dashroutingDetails.push({
        "userId": this.routingUserData.id, 
    "moduleId": this.moduleList[i].id,
    "pageId":this.pagesList[i].id,
    "printRoutingPageUrl": arr[i].print,
    "nextRoutingPageUrl": arr[i].route,
    "createdDate": new Date(),
    "createdBy": this.routingUserData.id,
    "updatedBy": this.routingUserData.id,
    "createdIP": null,
    "updatedIP": null,
    "updatedDate": new Date(),
    "tenantId": this.routingUserData.tenantId,
    "tenant": null,
    "branchId": this.routingUserData.branchId,
    "branch": null
      })
    }
  }
  this.routarrs.reset([]);

let filteredArray = dashroutingDetails.filter(function(element) {
  return   element.printRoutingPageUrl !== null && element.printRoutingPageUrl !== '' && element.nextRoutingPageUrl !== null && element.nextRoutingPageUrl !== '' ;
});

if(filteredArray.length>0){
  this.rolesService.create(`${this.apiUrl}/dashboardRouting/${this.routingUserData.tenantId}/${this.routingUserData.tenantId}`,filteredArray).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
   
  }, (error) => {
    this.errorSavemsg = true;
    setTimeout(() => {
      this.errorSavemsg = false;
    }, 4000);
    
  }, () => { 

    this.savemsg = true;
    setTimeout(() => {
      this.savemsg = false;
    }, 4000);
    this.routarrs.reset([]);
    this.servs();
  });
}
else{
  this.routarrs.reset([]);
  this.errorSavemsg = true;
  setTimeout(() => {
    this.errorSavemsg = false;
  }, 4000);

 

}
  }

  else{
    this.routarrs.reset([]);
    this.mandatorymsg = true;
    setTimeout(() => {
      this.mandatorymsg = false;
    }, 4000);

  }

}

//User Page Routing Update

routeUpdate(){
 let checkduplicate=[];
let postData=[];


 var UpdatedashroutingDetails=[];
  var arrUpdate=this.routarrs.value;
  for(var i=0;i<=arrUpdate.length-1;i++){
      UpdatedashroutingDetails.push({ 
    "moduleId": this.moduleList[i].id.toString(),
    "pageId":this.pagesList[i].id.toString(),
    "printRoutingPageUrl":arrUpdate[i].print,
    "nextRoutingPageUrl": arrUpdate[i].route,
      })


  }


   UpdatedashroutingDetails = UpdatedashroutingDetails.filter(function(element) {
    return  element.printRoutingPageUrl !== null && element.printRoutingPageUrl !== '' && element.nextRoutingPageUrl !== null && element.nextRoutingPageUrl !== '';
  });



  for(var j=0;j<=UpdatedashroutingDetails.length-1;j++){
    UpdatedashroutingDetails[j].printRoutingPageUrl=UpdatedashroutingDetails[j].printRoutingPageUrl.toString();
    UpdatedashroutingDetails[j].nextRoutingPageUrl=UpdatedashroutingDetails[j].nextRoutingPageUrl.toString();
  }

  for(var i=0;i<=this.getbyuserData.length-1;i++){
  checkduplicate.push({
    "moduleId":this.getbyuserData[i].moduleId,
    "pageId":this.getbyuserData[i].pageId,
    "printRoutingPageUrl":this.getbyuserData[i].printRoutingPageUrl,
    "nextRoutingPageUrl":this.getbyuserData[i].nextRoutingPageUrl
  });
}
checkduplicate = checkduplicate.filter(function(element) {
  return  element.printRoutingPageUrl !== null && element.printRoutingPageUrl !== '' && element.nextRoutingPageUrl !== null && element.nextRoutingPageUrl !== '' ;
});

for(var j=0;j<=checkduplicate.length-1;j++){
  checkduplicate[j].printRoutingPageUrl=checkduplicate[j].printRoutingPageUrl.toString();
  checkduplicate[j].nextRoutingPageUrl=checkduplicate[j].nextRoutingPageUrl.toString();
}

    let areEqual = JSON.stringify(checkduplicate)===JSON.stringify(UpdatedashroutingDetails)

  if(areEqual==false){
     for(var i=0;i<=arrUpdate.length-1;i++){
      if(arrUpdate[i].print===''||arrUpdate[i].print===null||arrUpdate[i].route===''||arrUpdate[i].route===null||isNaN(arrUpdate[i].print)||isNaN(arrUpdate[i].route)){      
        postData.push({
          "userId": this.routingUserData.id, 
      "moduleId": this.moduleList[i].id,
      "pageId":this.pagesList[i].id,
      "printRoutingPageUrl": "NaN",
      "nextRoutingPageUrl": "NaN",
      "createdDate":  new Date(),
      "createdBy": this.routingUserData.id,
      "updatedBy": this.routingUserData.id,
      "createdIP": null,
      "updatedIP": null,
      "updatedDate": new Date(),
      "tenantId": this.routingUserData.tenantId,
      "tenant": null,
      "branchId": this.routingUserData.branchId,
      "branch": null
        })

      }
      else{
        postData.push({
          "userId": this.routingUserData.id, 
      "moduleId": this.moduleList[i].id,
      "pageId":this.pagesList[i].id,
      "printRoutingPageUrl": arrUpdate[i].print,
      "nextRoutingPageUrl": arrUpdate[i].route,
      "createdDate":  new Date(),
      "createdBy": this.routingUserData.id,
      "updatedBy": this.routingUserData.id,
      "createdIP": null,
      "updatedIP": null,
      "updatedDate": new Date(),
      "tenantId": this.routingUserData.tenantId,
      "tenant": null,
      "branchId": this.routingUserData.branchId,
      "branch": null
        })
      }
    }
    postData = postData.filter(function(element) {
      return element.printRoutingPageUrl !== null && element.printRoutingPageUrl !== '' && element.nextRoutingPageUrl !== null && element.nextRoutingPageUrl !== ''  ;
    });
  
  }

if(postData.length>0){
  this.rolesService.create(`${this.apiUrl}/dashboardRouting/${this.routingUserData.tenantId}/${this.routingUserData.branchId}`,postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    
  }, (error) => {
    this.errorSavemsg = true;
    setTimeout(() => {
      this.errorSavemsg = false;
    }, 4000);
    
  }, () => { 
    this.routarrs.reset([]);
    this.servs();
    
    this.savemsg = true;
    setTimeout(() => {
      this.savemsg = false;
    }, 4000);

   
  });
  this.routarrs.reset([]);
  this.servs();

  }
  else{
    this.routarrs.reset([]);
  this.servs();
    this.dataExistsmsg = true;
    setTimeout(() => {
      this.dataExistsmsg = false;
    }, 4000);
  
  } 

  }

//User Page Routing End

// Radiology Page Access start 
rediologyData(){
  this.usertypeService.getall(`${this.fromtenantId}/${this.branchId}/servicesubcategory/getServiceSubCategory/rad`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
  
    this.radiologyList=data;
   }, (error) => {
   }, () => {
   });
}
radiologyDataGetByUserId(userData:any,UserIds:any){
  this.usertypeService.getall(`${userData.tenantId}/${userData.branchId}/labworkordermst/radOrderAccessDet/${UserIds}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.radioloUserDetails=data;
      /// Set Radiology - Investigation Page Access Settings
    
 var splittedRads=[];
 if(this.radioloUserDetails.length>0){
 this.radioloUserDetails.forEach(item => {
     splittedRads.push(item.serviceSubCategoryId)
     
   });

   this.registerForm.controls['radiologyPageAccess'].setValue(splittedRads);

 }
 else {
   this.registerForm.controls['radiologyPageAccess'].setValue("");
 }


    
    
   }, (error) => {
   }, () => {
   });

}

checkRadiologyModuleAccess(){
   
  this.usertypeService.getall(`${this.fromtenantId}/${this.branchId}/labworkordermst/GetRadModuleAccessForTenant`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    if(data==true){
      this.isRadiologyAccess=true;
    }
    else{
      this.isRadiologyAccess=false;
    }
   }, (error) => {
   }, () => {
   });
}

// Radiology Page Access End

  pharmacySettingsPopupClose() {
    this.pharmacySettingsPopup = false;
  }
  validateIsExists(event,type){ 
    if(event!=undefined  && event!=null &&  event.target.value?.length >= this.minMobileNumberLength 
      && event.target.value?.length <= this.maxMobileNumberLength){
    if(type==="mobile"){
      if ( event.target.value === this.userData.mobileNum) {

        this.isAlreadyExists = false;
        this.isAlreadyExistsMessage = "";
        return;
      }
        this.checkValidationIsExists(event.target.value,null);   
    }else if(type==="email"){
      this.checkValidationIsExists(null,event.target.value);   
    }
  }
  }
  checkValidationIsExists(mobileNumber,emailAddress){
    this.isAlreadyExists=false;
    this.isAlreadyExistsMessage="";
    let requestURL="";
    if(mobileNumber != null){   requestURL="users/validateTenantIsExists?mobileNumber="+mobileNumber}
    else if(emailAddress != null){   requestURL="users/validateTenantIsExists?emailAddress="+emailAddress};

    this.usertypeService.list(requestURL).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.isAlreadyExists=data.details.isExists;
      this.isAlreadyExistsMessage=data.details.type;
          
    }, (error) => {

    }, () => {

    });
  }
  savepharmacySetting() {
    var counterData = [];
    this.pharmacyData.forEach(pharmacy => {
      if (pharmacy.accessFlag == true) {
        counterData.push({
          userId: this.editUserId,
          counterId: pharmacy.counterId,
          accessFlag: pharmacy.accessFlag == true ? "true" : "false",
          createdBy: this.editUserId,
          createdDate: new Date(),
          tenantId: this.fromtenantId,
          branchId: pharmacy.branchId,
          isDefaultFlag: pharmacy.isDefaultFlag == true ? "true" : "false",
        });
      }
    });
    this.rolesService.create(`${this.apiUrl}/Pharmacy/${this.fromtenantId}/${this.branchId}/PharmacyCounterSetting/${this.editUserId}`, counterData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {

    }, (error) => {
      this.pharmacySettingsFaild = true;
      setTimeout(() => {
        this.pharmacySettingsFaild = false;
      }, 4000);
    }, () => {
      this.pharmacySettingsSuccess = true;
      setTimeout(() => {
        this.pharmacySettingsSuccess = false;
      }, 4000);
      this.pharmacySettingsPopup = false;
    });
  };

  getPharmacyAccessData(flag) {
    var branchdata = [];
    this.tenantBranchData.forEach(branch => {
      branchdata.push( branch.id);
    });
    let branchTenantData = {
      tenantId: this.fromtenantId,
      branchId: branchdata.join()
    }
    this.rolesService.create(`${this.apiUrl}/Pharmacy/${this.fromtenantId}/${this.branchId}/GetPharmacyDet`, branchTenantData).pipe(takeUntil(this.unsubscribe$)).subscribe((GetPharmacyDet: any) => {

    this.rolesService.list(`Pharmacy/${this.fromtenantId}/${this.branchId}/PharmacyCounterSettingBasedonTenant/${this.editUserId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((PharmacyCounterSetting: any) => {
      if (GetPharmacyDet.length > 0) {
        let pharmacyCounterData = GetPharmacyDet;
        this.pharmacyData = [];
        pharmacyCounterData.forEach(counter => {
          this.tenantBranchData.forEach(branch => {
            if(counter.branchId == branch.id){
          let pharmacyaccessData = {
                        branchName: branch.area,
                        counterId: counter.id,
                        counterName: counter.name,
                        tenantId: this.fromtenantId,
                        branchId: counter.branchId,
                        accessFlag: false,
                        isDefaultFlag:false
                        }
          this.pharmacyData.push(pharmacyaccessData);
        }
      });
      });
      this.pharmacyData.forEach(pharmData => {
        PharmacyCounterSetting.forEach(pharmSettings => {
        if(pharmSettings.counterId == pharmData.counterId){
          pharmData.accessFlag = pharmSettings.accessFlag == "true" ? true : false;
          pharmData.isDefaultFlag = pharmSettings.isDefaultFlag == true ? true : false
        };
      });
    });
      }
    }, (error) => { }
    , () => {
    });
    }, (error) => {
    }, () => {
      this.pharmacySettingsPopup = flag;
    });
  }


  checkPharmacyAccessFlag(data) {
    if (!!data) {
      this.pharmacyData.forEach(pharmacy => {
        if (pharmacy.counterId == data.counterId) {
          pharmacy.accessFlag = pharmacy.accessFlag;
        }
      });
    }
  }


  loadMasterlangData(): void {
    this.rolesService.list('Translation/LanguageMst?loadLangData=true').pipe(takeUntil(this.unsubscribe$)).subscribe(
      (value: any) => {
          this.languageList = value?.details ; 
          this.registerForm.get('preferredLang')?.setValue(1001);      
      });
  }  

  getData() {
    this.rolesService.list('Translation/LanguageMst?loadLangData=false').pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      const master = data.master;
      if( this.langCode !== undefined){
      this.filteredTransDetails = data.detail
        .filter(detail => detail.languageID == this.langCode)
        .reduce((acc, detail) => {
          const originalText = master.find(item => item.languageVariableId == detail.transMst.languageVariableID)?.originalText;
          if (originalText && this.langCode && detail.translatedText) {
            acc[originalText?.trim()] = detail.translatedText?.trim();
          }else{
            acc[originalText?.trim()] = detail.originalText?.trim();
          }
          return acc;
        }, {} as Record<string, string>);}else{
          this.filteredTransDetails = data.detail.reduce((acc, detail) => {
            const originalText = master.find(item => item.languageVariableId == detail.transMst.languageVariableID)?.originalText;
            acc[originalText?.trim()] = originalText?.trim();
            return acc;
          }, {} as Record<string, string>);
        }
        localStorage.setItem("Labels",JSON.stringify(this.filteredTransDetails))
    });
  }

  isPharmacyLocation: boolean = false;


  get fvalFilter(): { [key: string]: AbstractControl } { return this.filterForm.controls; }
  addFilter(){
    this.filterFlag = true;
    this.filterForm.reset();
    this.isSubmit=false;
    this.filterReference=[];
    this.multipleFlag=false;
    this.duplicateFlag = false;
    this.filterForm.get('defaultFlag').setValue('no');
    this.filterForm.get('hideZeroStockMedicine').setValue('no');
    this.isEditComponent = false;
  }
  selectReference(event){
    this.duplicateFlag=false;
    this.isPharmacyLocation = false;
   if(!!event[0]?.value) {
    if(event[0]?.value == 'Doctor'){
      this.filterReference = this.phyList;
    }else if (event[0]?.value == 'District'){
      this.filterReference = this.districtList;
    }
    else if(event[0]?.value == 'Prescription Location'){
      this.isPharmacyLocation = true;
      this.filterReference =this.pharmacyData.map(x => ({id: x.counterId, name: x.counterName}));
    }
    else if(event[0]?.value == 'Referral'){
      this.filterReference = this.refmodList;
    }
   }
  }
  saveFilter(event){
    this.isSubmit = true;
    event.target.disabled = true;
    if(this.filterForm.valid && !this.duplicateFlag && !this.multipleFlag){
      const addIfExists = (key: string, value: any, obj: any) => {
        if (value !== null && value !== undefined && value !== '') {
          obj[key] = value;
        }
      };

      const referralDetails = {};

      addIfExists('refClinicId', this.filterForm.get('refClinicId')?.value, referralDetails);
      addIfExists('empBranchId', this.filterForm.get('branchId')?.value, referralDetails);
      addIfExists('refEmpId', this.filterForm.get('refEmpId')?.value, referralDetails);
      addIfExists('refDocId', this.filterForm.get('refDocId')?.value, referralDetails);
      addIfExists('searchPatMobile', this.filterForm.get('searchPatMobile')?.value, referralDetails);
      addIfExists('searchRegId', this.filterForm.get('searchRegId')?.value, referralDetails);
      addIfExists('refRegId', this.filterForm.get('refRegId')?.value, referralDetails);
      addIfExists('referralcampid', this.filterForm.get('referralcampid')?.value, referralDetails);
      addIfExists('othersName', this.filterForm.get('othersName')?.value, referralDetails);
      addIfExists('othersCountryCode', this.filterForm.get('othersCountryCode')?.value, referralDetails);
      addIfExists('othersPhone', this.filterForm.get('othersPhone')?.value, referralDetails);
      addIfExists('othersAddress', this.filterForm.get('othersAddress')?.value, referralDetails);

      const data={
        FCtype:this.filterForm.get('filterType').value,
        referenceNo:this.filterForm.get('filterReference').value,
        defaultFlag:this.filterForm.get('defaultFlag').value == 'yes'?true:false,
        hideZeroStockMedicine:this.filterForm.get('hideZeroStockMedicine').value == 'yes' && this.filterForm.get('defaultFlag').value == 'yes' ? true : false,
        userId: null,
        TenantId:this.fromtenantId,
        BranchId:this.branchId,
        inputDataJson: JSON.stringify(referralDetails)
      }
        if (data.FCtype === 'Referral' && data.defaultFlag === true) {
          this.userFilterArray = this.userFilterArray.map((item, idx) => {
            if (item.FCtype === 'Referral' && !(this.isEditComponent && idx === this.editIndex)) {
              return { ...item, defaultFlag: false };
            }
            return item;
          });
        }

        const existing = this.userFilterArray.find(
          (x) => x.FCtype === this.filterForm.get('filterType')?.value && x.FCtype !== 'Referral' && x.defaultFlag && this.filterForm.get('defaultFlag')?.value ==='yes'
        );

        if (existing) {
          this.userFilterArray = this.userFilterArray.map((x) => {
            if (x?.referenceNo === existing?.referenceNo) {
              return { ...x, defaultFlag: false };
            } else if (x.referenceNo === this.filterForm.get('filterReference')?.value) {
              return { ...x, defaultFlag: true };
            }
            return x;
          });
        }
        if (this.isEditComponent) {
          this.userFilterArray[this.editIndex] = data; }
          else {
            this.userFilterArray.push(data);
          }
      
       this.filterForm.reset();
       this.isSubmit = false;
       this.filterFlag=false;
       this.dataFilterFlag = true;
       setTimeout(()=>{this.dataFilterFlag = false},3000)
       event.target.disabled = false;
    }else{
      this.dataFilterFlagCancel=true;
      setTimeout(()=>{this.dataFilterFlagCancel=false},3000)
      event.target.disabled = false;
    }
  }

  loadDistrict(){
  this.districtSrvc.list().pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.districtList = data;
  })
  }
  loadDoc(){
    this.phySrvc.list(`physicians/${this.fromtenantId}/${this.branchId}/GetAllInternalDoctor`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.phyList = data;
    })

  }

  userRef(x,type){
    if(!!x && !!type){
      if(type == 'Doctor'){
        const name = this.phyList?.find(y => y?.id == x);
        return  name?.doctor+ name?.displayName || ' '
      }else if (type == 'District'){
        const name = this.districtList?.find(y => y?.id == x)?.name;
        return name || ' '
      }
      else if (type == 'Prescription Location'){
        const name = this.pharmacyData?.find(y => y?.counterId == x);
        return name?.counterName || ' '
      } else if (type == 'Referral'){
          const name = this.refmodList.find(ref => ref?.id == x)?.name;
          return name || '';
      }
    }else{
      return ' '
    }
  }

  getUserFilter(){
    const tenantId = this.fromtenantId;
    const branchId = this.branchId;
    const userId = this.userData.id
    const params=new HttpParams().set('tenantId',tenantId).set('branchId',branchId).set('userId',userId)
    this.phySrvc.getFilterList(`users/GetUserFilterConditionDet`,params).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data.details?.length > 0){
      this.userFilterArray = data?.details?.map((x, index) => {
        return {
            FCtype: x?.fCtype,
            referenceNo: x?.referenceNo,
            defaultFlag: x?.defaultFlag,
            hideZeroStockMedicine:x?.hideZeroStockMedicine,
            userId: x?.userId,
            TenantId: x?.tenantId,
            BranchId: x?.branchId,
            inputDataJson: x?.inputDataJson
        };
    });   }else{this.userFilterArray=[];}

    }, (error) => {

    }, () => {

    });

  }

  saveAPI(det){
    if(this.userFilterArray?.length > 0){
      this.userFilterArray.forEach((item, index) => {
        item.userId=det[0].id
      })
      this.rolesService.create(`${this.apiUrl}/users/PostUserFilterConditionDet`,this.userFilterArray).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        const response = data; 
       
       })
    }

  }
  multipleFtn(event){
    const FCtype = this.filterForm.get('filterType').value;
    const refer = this.filterForm.get('filterReference').value;
    if(event.target.checked && FCtype && refer){
      if (FCtype === 'Referral') {
        const flag = this.userFilterArray?.filter(x => x?.FCtype === 'Referral' && x.defaultFlag === true);
        if (flag?.length > 0) {
          const isEditingCurrentDefault = this.isEditComponent &&
            flag.some(f => String(f.referenceNo) === String(this.editData?.referenceNo));
          this.multipleFlag = !isEditingCurrentDefault;
        } else {
          this.multipleFlag = false;
        }
      } else {
        const flag = this.userFilterArray?.filter(x => x?.FCtype == FCtype && x.defaultFlag == true);
        if(flag?.length > 0 && this.isEditComponent){
          if (flag[0]?.defaultFlag == this.editData?.defaultFlag) {
            this.multipleFlag = false;
          }else{this.multipleFlag = true;}
        }else{
          if (flag?.length > 0){this.multipleFlag = true;}
          else{this.multipleFlag = false;}
        }
      }
    }else{
      this.filterForm.get('defaultFlag').setValue('no');
      this.filterForm.get('filterType').markAsDirty();
      this.filterForm.get('filterReference').markAsDirty();
    }
  }
  checkDuplicate(event){
    if(event[0]?.value){
      var found = this.userFilterArray?.find(x => x?.referenceNo == event[0]?.value);
     const filterType = this.filterForm.get('filterType').value;
     this.userConditionErrorMessage = filterType === 'Doctor' ? 'Doctor' : filterType === 'District' ? 'District' : filterType === 'District' ? 'Prescription Location' : 'Referral';
      if(!!found && this.isEditComponent ==true)  {
        if (found?.referenceNo==this.editData?.referenceNo)
        {
        this.duplicateFlag=false;
        }
        else{
        this.duplicateFlag=true;  
        }
      }
      else
      if (!!found)
      {
         this.duplicateFlag=true;
      }
      else{
        this.duplicateFlag=false;
      }   
   }
}
  deleteFilter(index: number): void {
    this.deleteFlag = true;
    this.deleteIndex = index;
  }
  deleteFtn(confirm){
    if(confirm =='yes' && this.deleteIndex !== null ){
      this.userFilterArray.splice(this.deleteIndex, 1);
      this.deleteNotify = true;
      setTimeout(()=>{this.deleteNotify = false},3000)
    }
      this.deleteIndex = null;
      this.deleteFlag = false;
  }
  editFilter(x,i){
      this.filterFlag = true;
      this.isSubmit=false;
      this.isEditComponent= true;
      this.editData = x;
      this.editIndex = i;
      this.filterForm.get('filterType').setValue(x?.FCtype);

      // Populate the reference items list based on filter type (mirrors selectReference logic)
      if(x?.FCtype == 'Doctor') {
        this.filterReference = this.phyList;
      } else if(x?.FCtype == 'District') {
        this.filterReference = this.districtList;
      } else if(x?.FCtype == 'Prescription Location') {
        this.filterReference = this.pharmacyData.map(p => ({id: p.counterId, name: p.counterName}));
      } else if(x?.FCtype == 'Referral') {
        this.filterReference = this.refmodList;
      }

      this.filterForm.get('filterReference').setValue((x?.FCtype=="Prescription Location" || x?.FCtype=="Referral") ?parseInt(x?.referenceNo):x?.referenceNo)
      if(x?.defaultFlag){
        this.filterForm.get('defaultFlag').setValue('yes');
      }else{
        this.filterForm.get('defaultFlag').setValue('no');
      }
      if(x?.hideZeroStockMedicine){
        this.filterForm.get('hideZeroStockMedicine').setValue('yes');
      }else{
        this.filterForm.get('hideZeroStockMedicine').setValue('no');
      }
      if(x?.inputDataJson && x?.FCtype == 'Referral'){
        const inputData = JSON.parse(x?.inputDataJson);
        // Determine which referral sub-mode is selected so conditional fields render
        const refMode = this.refmodList.find(r => r.id == parseInt(x?.referenceNo));
        if(refMode){
          this.selectedReferralModeName = refMode.name;
          if(refMode.name === 'Employee') {
            this.loadTenantBranch();
          }
          // Load the sub-list (e.g. refList for Clinic/Lab Center) then patch values
          this.refListData(refMode.name, () => {
            // Patch non-dropdown fields and branchId immediately
            this.filterForm.patchValue({
              ...(inputData?.empBranchId && { branchId: inputData?.empBranchId }),
              ...(inputData?.refClinicId && { refClinicId: inputData?.refClinicId }),
              ...(inputData?.searchPatMobile && { searchPatMobile: inputData?.searchPatMobile }),
              ...(inputData?.searchRegId && { searchRegId: inputData?.searchRegId }),
              ...(inputData?.refRegId && { refRegId: inputData?.refRegId }),
              ...(inputData?.referralcampid && { referralcampid: inputData?.referralcampid }),
              ...(inputData?.othersName && { othersName: inputData?.othersName }),
              ...(inputData?.othersCountryCode && { othersCountryCode: inputData?.othersCountryCode }),
              ...(inputData?.othersPhone && { othersPhone: inputData?.othersPhone }),
              ...(inputData?.othersAddress && { othersAddress: inputData?.othersAddress })
            });
            // refEmpId: behind *ngIf="...Employee && branchId?.value" — needs branchId rendered first
            // refDocId: docList/docExList just changed; Angular needs a tick to push new items to ngx-select
            // Defer both so ngx-select has items loaded and is in the DOM before the value is written
            if(inputData?.refEmpId || inputData?.refDocId) {
              setTimeout(() => {
                this.filterForm.patchValue({
                  ...(inputData?.refEmpId && { refEmpId: inputData?.refEmpId }),
                  ...(inputData?.refDocId && { refDocId: inputData?.refDocId })
                });
              }, 0);
            }
          });
        }
      }

  }
  yesFilter(x: any): void {  
    this.filterForm.get('defaultFlag').setValue('yes');
    this.multipleFlag = false;
    this.multipleData = this.filterForm.get('filterReference').value;
}
checkDefault(val){
  const pre = this.pharmacyData.filter(x => x?.isDefaultFlag == true );
  if(pre?.length > 1){
    this.isDefaultPopup =true;
    this.yesDefault = val;
  }else{
    this.isDefaultPopup = false;
    this.pharmacyData.forEach(pharmacy => {
      if (pharmacy.counterId == val.counterId) {
        pharmacy.isDefaultFlag = pharmacy.isDefaultFlag;
      }
    });

  }
}
defaultYesFlag(val){
  if(val=='yes'){
    this.pharmacyData.forEach(pharmacy => pharmacy.isDefaultFlag = false)
    this.pharmacyData.forEach(pharmacy => {
      if (pharmacy.counterId == this.yesDefault.counterId) {
        pharmacy.isDefaultFlag = true;
      }
    });
    this.isDefaultPopup =false;
  }
  else{
    this.isDefaultPopup =false;
    this.pharmacyData.forEach(pharmacy => {
      if (pharmacy.counterId == this.yesDefault.counterId) {
        pharmacy.isDefaultFlag = false;
      }
    });
    this.yesDefault = {};

  }
}

  loadGeo(): void {
    if(this.countryList?.length > 0)return;
    this.rolesService.list(`countries/getCountryMaster`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryList = data.details;
    })}

  fetchJobCategory() {
    this.categorySrvc.list("jobcategory").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.jobCategoryData = data;})
  }

  onFilterReferenceChange(event){
    this.selectedReferralModeName = '';
    this.filterForm.controls.othersCountryCode.setValue(this.countryCode);
    this.checkDuplicate(event);
    this.selectReferralDropdownChange(event);
  }

  selectReferralDropdownChange(event){
    this.selectedReferralModeName = event[0]?.text;
    if(event.length>0){
      this.filterForm.controls.refDocId.clearValidators();
      this.filterForm.controls.refClinicId.clearValidators();
      this.filterForm.controls.othersName.clearValidators();
      this.filterForm.controls.refEmpId.clearValidators();
      this.filterForm.controls.referralcampid.clearValidators();
      if(event[0]?.text=="Clinic/Lab Center"){
            this.refListData(event[0]?.text);
            this.filterForm.controls.refEmpId.setValue(null);
            this.filterForm.controls.refClinicId.setValue(null);
            this.filterForm.controls.refDocId.setValue(null);
            this.filterForm.controls.othersName.setValue(null);
            this.filterForm.controls.othersPhone.setValue(null);
            this.filterForm.controls.othersAddress.setValue(null);
            this.filterForm.controls.referralcampid.setValue(null);
            this.filterForm.controls.refClinicId.setValidators([Validators.required]);
      } else if(event[0]?.text=="Employee"){
          this.loadTenantBranch();
            this.refListData(event[0]?.text);
            this.filterForm.controls.refEmpId.setValue(null);
            this.filterForm.controls.refClinicId.setValue(null);
            this.filterForm.controls.refDocId.setValue(null);
            this.filterForm.controls.othersName.setValue(null);
            this.filterForm.controls.othersPhone.setValue(null);
            this.filterForm.controls.othersAddress.setValue(null);
            this.filterForm.controls.referralcampid.setValue(null);
            this.filterForm.controls.refEmpId.setValidators([Validators.required]);
      } else if(event[0]?.text=="Internal Physician" || event[0]?.text=="Physician" ){      
            this.refListData("Internal Physician");
            this.filterForm.controls.refEmpId.setValue(null);
            this.filterForm.controls.refClinicId.setValue(null);
            this.filterForm.controls.refDocId.setValue(null);
            this.filterForm.controls.othersName.setValue(null);
            this.filterForm.controls.othersPhone.setValue(null);
            this.filterForm.controls.othersAddress.setValue(null);
            this.filterForm.controls.referralcampid.setValue(null);     
      } else if(event[0]?.text=="External Physician" || event[0]?.text=="ExternalPhysician"){
              this.refListData("External Physician");
              this.filterForm.controls.refEmpId.setValue(null);
              this.filterForm.controls.refClinicId.setValue(null);
              this.filterForm.controls.refDocId.setValue(null);
              this.filterForm.controls.othersName.setValue(null);
              this.filterForm.controls.othersPhone.setValue(null);
              this.filterForm.controls.othersAddress.setValue(null);
              this.filterForm.controls.referralcampid.setValue(null);
              this.filterForm.controls.refDocId.setValidators([Validators.required]);
      
      } else if(event[0]?.text=="Camp"){
              this.loadCampData();
              this.filterForm.controls.refEmpId.setValue(null);
              this.filterForm.controls.refClinicId.setValue(null);
              this.filterForm.controls.refDocId.setValue(null);
              this.filterForm.controls.othersName.setValue(null);
              this.filterForm.controls.othersPhone.setValue(null);
              this.filterForm.controls.othersAddress.setValue(null);
              this.filterForm.controls.referralcampid.setValue(null);
              this.filterForm.controls.referralcampid.setValidators([Validators.required]);
      } else if(event[0]?.text=="Others"){
              this.filterForm.controls.refEmpId.setValue(null);
              this.filterForm.controls.refClinicId.setValue(null);
              this.filterForm.controls.refDocId.setValue(null);
              this.filterForm.controls.othersName.setValue(null);
              this.filterForm.controls.othersPhone.setValue(null);
              this.filterForm.controls.othersAddress.setValue(null);
              this.filterForm.controls.referralcampid.setValue(null);
              this.filterForm.controls.othersName.setValidators([Validators.required]);
            }
            else{
              this.updateReferralDet();
            }
    }
  }

  refListData(referralType, callback?: () => void) {
    if (referralType === 'Clinic/Lab Center' && this.refList?.length > 0) { if (callback) callback(); return false; }
    if (referralType === 'Employee' && this.empList?.length > 0) { if (callback) callback(); return false; }
    if (referralType === 'Internal Physician' && this.docList?.length > 0) { if (callback) callback(); return false; }
    if (referralType === 'External Physician' && this.docExList?.length > 0) { if (callback) callback(); return false; }

    let referralObj = this.refmodList.find(ref => ref.name === referralType);
    if (!referralObj) return;
    this.employeeSrvc.reflist(`tenants/${this.fromtenantId}/${this.branchId}/referrals/getPhyEmpClinicAsReferral?referralType=${referralObj.id}`).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (data: any) => {
        if (referralType ===  'Clinic/Lab Center') {
          this.refList = data?.details?.map(s => Object.assign(s,{optionName: s.name+" "+s.clinicName}))
        } else if (referralType === 'Employee') {
          this.empList = data.details || [];
        } else if (referralType === 'Internal Physician' ) {
          this.docList = data.details || [];
          this.docList?.forEach(item => {
            item.name = `${item?.doctor || ''}${item?.name || ''}`;
        });
        } else if (referralType === 'External Physician') {
          this.docExList = data.details || [];
        }
        if (callback) callback();
      },
      (error) => {
      }
    );
  }

  loadTenantBranch(): void { 
    this.tenantSrvc.list(`${this.fromtenantId}/tenantbranch/fetchBranches`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.branchDetails=data.details
    }, (error) => {
 
    }, () => {
    });
  }

  loadCampData (){
    this.patAptSrv.list(`campMst/${this.fromtenantId}/${this.branchId}/GetCampMstdatas`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.campData = data.details
      },
    );
  }

  updateReferralDet(){
    this.filterForm.controls.refEmpId.setValue(null);
    this.filterForm.controls.refClinicId.setValue(null);
    this.filterForm.controls.refDocId.setValue(null);
    this.filterForm.controls.othersName.setValue(null);
    this.filterForm.controls.othersPhone.setValue(null);
    this.filterForm.controls.othersAddress.setValue(null);
    this.filterForm.controls.referralcampid.setValue(null);

    this.filterForm.controls.refEmpId.clearValidators();
    this.filterForm.controls.refEmpId.updateValueAndValidity();

    this.filterForm.controls.refDocId.clearValidators();
    this.filterForm.controls.refDocId.updateValueAndValidity();

    this.filterForm.controls.refClinicId.clearValidators();
    this.filterForm.controls.refClinicId.updateValueAndValidity();
    
    this.filterForm.controls.othersName.clearValidators();
    this.filterForm.controls.othersName.updateValueAndValidity();

    this.filterForm.controls.referralcampid.clearValidators();
    this.filterForm.controls.referralcampid.updateValueAndValidity();
  }

  onSearchFieldChange(type: string, event: any): void {
    let searchData = {
      patientRegNo: '',
      patientMobile: '',
      tenantId: this.fromtenantId,
     
    };
    if(event.target.value != ''){
        if (type === 'mobile') {
          this.PatientList = []
          this.filterForm.controls["searchRegId"].setValue(null);
          searchData.patientMobile = this.filterForm.controls["searchPatMobile"].value;
        } else if (type === 'regNum') {
          this.PatientList = []
          this.filterForm.controls["searchPatMobile"].setValue(null);
          searchData.patientRegNo = this.filterForm.controls["searchRegId"].value;
        } 
        this.searchRegMob(searchData)
    }else{
      this.filterForm.controls["refRegId"].setValue(null);
    }
  }

  searchRegMob(searchData){
        this.patRegSrvc.searchList('multiBranchAppointment/filterByPatientRegDetail', searchData)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (data: any) => {
          if (data.length > 0) {
            this.PatientList = data;
            if (this.PatientList.length === 1){
              this.filterForm.controls["refRegId"].setValue(this.PatientList[0].regId);
            }
          }
        },
        (error) => {
        }
      );
  }
}
